import React from 'react';
import style from '../../assets/scss/components/pages/MainPage.module.scss';
import { convertKeysToCamelCase } from '../../helpers/baseHelpers';
import { Greeting } from '../common/Greeting';

export const ForbiddenPage: React.FC = () => {
  const { wrapper, greetingText } = convertKeysToCamelCase(style);

  return (
    <div className={wrapper}>
      <Greeting className={greetingText} text={`403 Forbidden`} />
    </div>
  );
};
